export const SEARCH_BAR_SECTION_HEIGHT = 60;